import { defineStore } from 'pinia'
import { useRuntimeConfig } from 'nuxt/app'

type FlagsState = {
  isFetched: boolean
  flags: {
    signup_campaign_men_active: boolean
    signup_campaign_men_active_last_day: boolean
    signup_campaign_men_active_end_date: string | null
    signup_campaign_socks_active: boolean
    signup_campaign_socks_active_last_day: boolean
    signup_campaign_socks_active_end_date: string | null
  }
}

export const useFlagsStore = defineStore('flags', {
  state: (): FlagsState => ({
    isFetched: false,
    flags: {
      signup_campaign_men_active: false,
      signup_campaign_men_active_last_day: false,
      signup_campaign_men_active_end_date: null,
      signup_campaign_socks_active: false,
      signup_campaign_socks_active_last_day: false,
      signup_campaign_socks_active_end_date: null
    }
  }),
  getters: {
    isTwoForOneCampaign: (state: FlagsState): boolean => state.flags.signup_campaign_men_active,
    isTwoForOneCampaignEndDate: (state: FlagsState): string | null => state.flags.signup_campaign_men_active_end_date,
    isTwoForOneCampaignLastDay: (state: FlagsState): boolean => state.flags.signup_campaign_men_active_last_day,
    isSocksTwoForOneCampaign: (state: FlagsState): boolean => state.flags.signup_campaign_socks_active,
    isSocksTwoForOneCampaignEndDate: (state: FlagsState): string | null => state.flags.signup_campaign_socks_active_end_date,
    isSocksTwoForOneCampaignLastDay: (state: FlagsState): boolean => state.flags.signup_campaign_socks_active_last_day,
    isFlagsFetched: (state: FlagsState): boolean => state.isFetched
  },
  actions: {
    async fetchFlags() {
      const {
        public: { API_URL }
      } = useRuntimeConfig()

      const data = await $fetch<any>(`${API_URL}/v2/flags`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      })

      this.flags = data
      this.isFetched = true

      return data
    }
  }
})
